// Explosiveness (Uranus): the first star of every constellation scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const explosiveness: AlignmentDef = {
  id: 'explosiveness',
  planet: 'uranus',
  name: 'Explosiveness',
  text: () => `The first star of every constellation scores +${N.explosivenessPercent}%.`,
  starPercent: (star) => (star.index === 0 ? N.explosivenessPercent : 0),
};
